module.exports = __webpack_public_path__ + "img/LoginPage.9b37c731.jpg";